import { Env } from '/@/Env';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';

export const router =
  Env.isDevelopment() || Env.isSandbox()
    ? [
        CurrentEstateRouteConfig.factory({
          path: '/dev/steps/:key',
          name: 'dev-guidancesteps',
          component: () => import('/@/modules/dev/pages/GuidanceStepTestPage.vue'),
          meta: { authOnly: true }
        }).build(),
        CurrentEstateRouteConfig.factory({
          path: '/dev/stepviz',
          name: 'dev-stepviz',
          component: () => import('/@/modules/dev/pages/GuidanceStepVizPage.vue'),
          meta: { authOnly: true }
        }).build(),
        {
          path: '/dev/benchmark',
          name: 'dev-benchmark',
          component: () => import('/@/modules/dev/pages/BenchmarkPage.vue'),
          meta: { authOnly: false }
        },
        {
          path: '/dev/scan-debug',
          name: 'dev-scan-debug',
          component: () => import('/@/modules/dev/pages/ScanDebugPage.vue'),
          meta: { authOnly: false }
        },
        {
          path: '/dev/preview/couples-space-decision-card',
          name: 'dev-preview-couples-space-decision-card',
          component: () => import('/@/modules/dev/pages/PreviewCouplesSpaceDecisionCardPage.vue'),
          meta: { authOnly: false }
        }
      ]
    : [];
